import React from 'react';


const CookiePolicy = () => {

    return (
        <>
            <iframe
                title="privacy policy"
                src="/cookie_policy.html"
                style={{
                    width: '100%',
                    height: '100vh',
                    border: 'none'
                }}
            />
        </>
    );
};

export default CookiePolicy;